import { Component, Input } from '@angular/core';
import { GtdNgWidgetComponentAbstract } from 'gtd-ng-widget';
import { ProfileResponse } from './profile.response';

@Component({
  selector: 'gtd-widget-affiliates-profile',
  templateUrl: './profile.component.html',
})
export class AffiliateProfileComponent extends GtdNgWidgetComponentAbstract {
  public data: ProfileResponse = new ProfileResponse();
  @Input() id: number;
  @Input() title: string = null;
  @Input() customClass: string;
  public length = 12;
  protected readonly key: string = 'Affiliate\\Profile';
}
